namespace GeniuzPOS.CustomReport {
    export class ReportCusSaleReportColumns {
        static columnsKey = 'CustomReport.ReportCusSaleReport';
    }
}
